<template>
    <Sider hide-trigger class="em-side">
        <div class="em-side-logo">
            <img src="@/assets/image/logo-dark.png" alt="logo">
        </div>
        <div class="em-side-child">
            <Menu theme="light" :style="{height:($store.state.tableHight - 64) + 'px'}" width="auto" :open-names="[$store.state.open_names]" :active-name="$store.state.active_names" accordion>
                <template v-for="(item,index) in menu" :key="index">
                    <MenuItem :name="item.id" v-if="!item.Childrens" @click="GoLink(item.url)">
                        <Icon :type="item.icon"/>
                        {{item.title}}
                    </MenuItem>
                    <Submenu :name="item.id" v-else>
                        <template v-slot:title>
                            <Icon :type="item.icon"/>
                            {{item.title}}
                        </template>
                        <MenuItem :name="String(item.id)+'-'+String(items.id)" v-for="(items,indexs) in item.Childrens" :key="indexs" @click="GoLink(items.url)"><Icon :type="!!items.icon ? items.icon : 'ios-arrow-forward'"/> {{items.title}}</MenuItem>
                    </Submenu>
                </template>
            </Menu>
        </div>
    </Sider>
</template>

<script>
export default {
    name: 'Side',
    components: {},
    props:{
        menu_id : { default : "1" }
    },
    data () {
        return {
            theme: 'dark',
            menu:[],
        }
    },
    created(){
        this.GetMenu();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    methods: {
        GetMenu(){
            let that = this;
            that.menu =  JSON.parse(decodeURIComponent(this.$store.state.auth));
            let route_info = this.$route;
            let auth =  JSON.parse(decodeURIComponent(this.$store.state.auth));
            auth.forEach((item) => {
                if(item.id == route_info.meta.id){
                    console.log(item)
                    this.$store.commit('SET_OPEN_NAMES' , item.id);
                    this.$store.commit('SET_ACTIVE_NAMES' ,item.id);
                    this.$store.commit('SET_PARENT_ROUTER_NAME' ,item.title);
                }else if(item.Childrens){
                    let children = item.Childrens;
                    children.forEach((items) => {
                        if(items.id == route_info.meta.id){
                            this.$store.commit('SET_OPEN_NAMES' , item.id);
                            this.$store.commit('SET_ACTIVE_NAMES' ,String(item.id)+'-'+String(items.id));
                            this.$store.commit('SET_PARENT_ROUTER_NAME' ,item.title);
                        }
                    })
                }
            })
        },

        GoLink(url) {
            let that = this;
            that.$router.push({
                path : url,
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
